import { Injectable } from '@angular/core';
import { User } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public loading: boolean = false;
  public user_id: string;
  public sala_id: string;
  public parking_id: string;
  public sala_nombre: string;
  public ubicacion: string;
  public nombre: string;
  public email: string;
  public pass: string;
  public colors = [ '#27CDCE', '#8B7452', '#19E396', '#75B2B3', '#007A92', '#E3A16C' , '#6965A7' , '#3B69CE' , '#FFBD86'];
  public permisos = '';
  // public dataUser: any[] = [];
  public msg_error: string = '';
  public msg_accept: string = '';
  public data: User;

  constructor() { }

  playAudio() {
    const audio = new Audio();
    audio.src = "../assets/pi.wav";
    audio.load();
    audio.play();
  }

  checkArr(data) {
    if ( data.length > 0 ) { return true; }

    return false;
  }

  PublicMsg(data) {
    this.msg_accept = data['status_message'];
    setTimeout(() => this.msg_accept = '', 1500);
  }

  PublicError(error) {
    this.msg_error = error.error.status_message;
    setTimeout(() => this.msg_error = '', 1500);
  }

  ErrorSwal(er){
    Swal.fire({
      title: 'ERROR',
      text: er.error.data,
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }

  SuccessSwal(hdr,msg){
    Swal.fire({
      title: hdr,
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK'
    });
  }

  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [year, month, day].join('-');
  }

  formatDateES(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [day, month, year].join('-');
  }

  getLastMonth() {
    const date = new Date();
    const newDate = new Date(date.setMonth(date.getMonth() - 1 ));
    return this.formatDate(newDate);
  }


}
